import axios from '@/libs/api.request'


export const get_product_published_list = (data)=>{
    return axios.request({
        url: 'api_weixin/get_product_published_list',
        data,
        method: 'post'
    })
};

export const get_product_published_info = (data)=>{
    return axios.request({
        url: 'api_weixin/get_product_published_info',
        data,
        method: 'post'
    })
};

export const get_product_published_promote = (data)=>{
    return axios.request({
        url: 'api_weixin/get_product_published_promote',
        data,
        method: 'post'
    })
};

export const get_user_promote_poster = (data)=>{
    return axios.request({
        url: 'api_weixin/get_user_promote_poster',
        data,
        method: 'post'
    })
};

export const get_product_published_introduction = (data)=>{
    return axios.request({
        url: 'api_weixin/get_product_published_introduction',
        data,
        method: 'post'
    })
};
export const get_product_published_notice = (data)=>{
    return axios.request({
        url: 'api_weixin/get_product_published_notice',
        data,
        method: 'post'
    })
};
export const get_my_order_list = (data)=>{
    return axios.request({
        url: 'api_weixin/get_my_order_list',
        data,
        method: 'post'
    })
};
export const get_sale_tool_group_rule_info = (data)=>{
    return axios.request({
        url: 'api_weixin/get_sale_tool_group_rule_info',
        data,
        method: 'post'
    })
};
export const get_sale_tool_group_rule_list = (data)=>{
    return axios.request({
        url: 'api_weixin/get_sale_tool_group_rule_list',
        data,
        method: 'post'
    })
};
export const get_sale_group_info = (data)=>{
    return axios.request({
        url: 'api_weixin/get_sale_group_info',
        data,
        method: 'post'
    })
};
export const draw_coupon = (data)=>{
    return axios.request({
        url: 'api_weixin/draw_coupon',
        data,
        method: 'post'
    })
};
export const get_user_coupon_list = (data)=>{
    return axios.request({
        url: 'api_weixin/get_user_coupon_list',
        data,
        method: 'post'
    })
};
export const get_coupon_product_list = (data)=>{
    return axios.request({
        url: 'api_weixin/get_coupon_product_list',
        data,
        method: 'post'
    })
};
